:host {
  /**
   * @prop --c-card-title-color: Card title color
   * @prop --c-card-title-underline-color: Card title underline color
   */
  --_c-card-title-color: var(--c-card-title-color, var(--c-text-system));
  --_c-card-title-underline-color: var(--c-card-title-underline-color, var(--c-primary-600));

  color: var(--_c-card-title-color);
  display: block;
  font-family: var(--c-font-family);
  font-size: 1rem;
  font-weight: 500;
  text-transform: uppercase;
  text-wrap: balance;
}

.c-card-title {
  $this: &;

  padding-inline: var(--_c-card-gap, 24px);

  &__header {
    p {
      margin: 0;
    }
  }

  &--actions {
    display: flex;
    flex-wrap: wrap;
    align-items: start;
    flex: 0 0 auto;
    gap: 8px;

    &#{$this}--wrapped {
      #{$this}__actions {
        justify-content: start;
      }
    }
  }

  &__underline {
    background-color: var(--_c-card-title-underline-color);
    border-radius: 4px;
    height: 4px;
    margin-top: 10px;
    width: 44px;
  }

  &__actions {
    justify-content: end;
    align-items: center;
    display: flex;
    flex-wrap: wrap-reverse;
    gap: 8px;
    flex: 1;
  }
}
